export default [
    { value: 'en-us', label: 'English' },
];
